"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEndConsumers = useEndConsumers;
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _contexts = require("../contexts");
var _logger = require("../logger");
function useEndConsumers() {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerId
  } = (0, _react.useContext)(_contexts.wizardContext);
  const headers = {
    'x-tenant-context': tenant
  };
  const swrOptions = {
    ..._checkoutUtils.errorHandlingSwrOptions,
    onSuccess: () => {
      (0, _logger.logDebug)('useEndConsumers() hook finished successfully');
    }
  };
  const {
    data,
    error,
    isValidating: isLoading
  } = (0, _globalApiClientReact.useGetCustomerEndConsumers)(customerId, headers, {
    swr: swrOptions
  });
  return {
    data,
    error,
    isLoading
  };
}
